import '../vendor/jquery.betterScroll.custom';

$(document).ready(function() {
	$("#preloader").remove();
    let $quizModel = $('#quiz-model'), 
        numOfQuestions = $quizModel.find('.page-section').length - 1, // Exclude the start button
        $form = $quizModel.closest('form'), $currentSection, currentQuestion = 1, answered = 0,
        scrollToIndex = 0;
    
    $quizModel.betterScroll({
        scrollUpSelector: '.button-up', 
        scrollDownSelector: '.button-down',
    });
    
    $('.question_list input').on('change', function() {
        $('.question_list input:not(:checked)').closest('.radio').removeClass("selected");
        $('.question_list input:checked').closest('.radio').addClass("selected");

        $currentSection = $(this).closest('.page-section');
        $currentSection.addClass('ok');

        currentQuestion = $currentSection.data('section-index');
        answered = $quizModel.find('.page-section.ok').length;

        if (answered == numOfQuestions) {
            $form.submit();
        } else {
            scrollToIndex = $quizModel.find('.page-section:not(.ok,.section-start):first').data('section-index');
            $.fn.betterScrollTransform(scrollToIndex);
        }
    });

    $('.start-quiz').on('click', function(e) {
        e.preventDefault();
        $.fn.betterScrollDown();
    });
});